import { Component, OnInit } from '@angular/core'
import { ApiService, UserInfo } from '../../services/api.service'
import { environment } from '../../../environments/environment'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { HeaderComponent } from '@components/header/header.component'
import { GenericHeaderComponent } from '@components/generic-header/generic-header.component'
import { CompanyComponent } from './company/company.component'
import { UserComponent } from './user/user.component'
import { OpportunitiesComponent } from './opportunities/opportunities.component'
import { EmployeesComponent } from './employees/employees.component'
import { ActivatedRoute } from '@angular/router'
import { AssociateShopsComponent } from './associate-shops/associate-shops.component'

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.scss',
    imports: [CommonModule, TranslateModule, HeaderComponent, GenericHeaderComponent, CompanyComponent, UserComponent, EmployeesComponent, AssociateShopsComponent, OpportunitiesComponent],
    standalone: true,
})

export class ProfileComponent implements OnInit {
    userInfo: UserInfo
    currentTab: string = 'PROFILE'
    protected readonly environment = environment

    isActiveLeadsB2C: boolean = false;
    isRetailAccount: boolean = false;
    hasChildAccounts?: boolean = false;
    isTemporallyDisabledOnLeads: boolean = false;
    unsubscribeReason: string;

    constructor(private api: ApiService, private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.currentTab = params['tab'] ?? 'PROFILE';
        });

        this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo
            this.isActiveLeadsB2C = !!userInfo.isActiveLeadsB2C;
            this.isRetailAccount = userInfo.accountType === 'RETAIL';
            this.hasChildAccounts = userInfo.hasChildAccounts;
            if(userInfo.accountType && ['DESIGNER','ARCHITECT'].includes(userInfo.accountType)) {
                this.currentTab = 'COMPANY'
            }

        });

        this.api.getUnsubscribeFromLeadsReason().subscribe({
            next: (res) => {
                this.unsubscribeReason = res.reason;         
                this.isTemporallyDisabledOnLeads = res.reason === 'I’m temporarily closing the store';
                
            },
            error: (err) => {
                console.error('Error al obtener razón de la baja:', err);
            }
        });
    }

    setCurrentTab(tab: string) {
        this.currentTab = tab
        // this.onTabSwitch.emit(tab)
        // if (tab == 'COMMENTS') this.scrollIntoView()
    }
}
